'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import ReactGA from 'react-ga4';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { amplitudeInstance } from '../../config/amplitude';
import AuthContext from '../../context/AuthContext';
import buildRouteUrl from '../../helpers/buildRouteUrl';
import useIntl from '../../hooks/useIntl';
import useModal from '../../hooks/useModal';
import { Link } from '../../i18n/navigation';
import * as fbq from '../../lib/fpixel';
import BrandLogo from '../BrandLogo';
import Search from '../Search';
// import SubscriptionsPlansModal from '../SubscriptionPlansModal';

function Header() {
  const $ = _c(59);
  const pathname = usePathname();
  const intl = useIntl();
  const t = useTranslations();
  const auth = useContext(AuthContext);
  let pathnameWithoutLocale;
  if ($[0] !== intl.locale || $[1] !== pathname) {
    pathnameWithoutLocale = pathname.replace(`${intl.locale}`, "");
    if (pathnameWithoutLocale.includes("//")) {
      pathnameWithoutLocale = pathnameWithoutLocale.slice(1);
    }
    $[0] = intl.locale;
    $[1] = pathname;
    $[2] = pathnameWithoutLocale;
  } else {
    pathnameWithoutLocale = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = buildRouteUrl("/");
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href={t0} className="mr-2 md:mr-8" prefetch={true}><BrandLogo className="h-[22px] w-[144px]" priority={true} /></Link>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = buildRouteUrl("/");
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `no-underline ${pathnameWithoutLocale === "/" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`;
  let t4;
  if ($[6] !== t) {
    t4 = t("header.links.home");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Link href={t2} className={t3} prefetch={false}>{t4}</Link>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== auth.isLoading || $[12] !== auth.isLoggedIn || $[13] !== pathnameWithoutLocale || $[14] !== t) {
    t6 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathnameWithoutLocale === "/my-progress" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[11] = auth.isLoading;
    $[12] = auth.isLoggedIn;
    $[13] = pathnameWithoutLocale;
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== auth.isLoading || $[17] !== auth.isLoggedIn || $[18] !== pathnameWithoutLocale || $[19] !== t) {
    t7 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathnameWithoutLocale === "/my-list" ? "text-white font-bold" : "text-[#666] hover:opacity-[0.5] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[16] = auth.isLoading;
    $[17] = auth.isLoggedIn;
    $[18] = pathnameWithoutLocale;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className="flex flex-row items-center mr-8">{t1}<div className="hidden md:flex flex-row gap-x-3">{t5}{t6}{t7}</div></div>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="hidden md:flex flex-row flex-1 justify-end"><div className="md:w-[80%]"><Search /></div></div>;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== auth || $[27] !== pathname || $[28] !== t) {
    t10 = <div className="flex flex-row items-center ml-0 md:ml-6">{auth.isLoggedIn ? <DropdownMenu.Root><DropdownMenu.Trigger><span className="text-white hover:text-[#666] font-bold">{auth.userData?.name}</span></DropdownMenu.Trigger><DropdownMenu.Portal style={{
          zIndex: 100
        }} className="z-10"><DropdownMenu.Content align="end" sideOffset={5} className="w-48 rounded-lg p-2 shadow-md md:w-56 bg-black z-10"><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/users/me")} className="flex-grow text-white" prefetch={true}>{t("profile.title")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><Link href={buildRouteUrl("/settings")} className="flex-grow text-white" prefetch={true}>{t("profile.settings")}</Link></DropdownMenu.Item><DropdownMenu.Item className="flex items-center rounded-md px-2 h-10 text-sm outline-none focus:bg-gray-200 cursor-pointer"><span onClick={() => auth.destroySession()} className="flex-grow text-white">{t("profile.logout")}</span></DropdownMenu.Item></DropdownMenu.Content></DropdownMenu.Portal></DropdownMenu.Root> : <Link onClick={() => amplitudeInstance.logEvent("Header Go To Login Button", {
        page_path: pathname
      })} href={buildRouteUrl("/login")} className="md:ml-4 text-white hover:text-gray-200 font-semibold uppercase">Login</Link>}</div>;
    $[26] = auth;
    $[27] = pathname;
    $[28] = t;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t8) {
    t11 = <div className="flex flex-row justify-between items-center px-4 md:px-10 py-4 w-full h-[64px] min-h-[64px]">{t8}{t9}{t10}</div>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = buildRouteUrl("/");
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const t13 = `no-underline ${pathname === "/" ? "text-white font-bold" : "text-[#666] regular"}`;
  let t14;
  if ($[34] !== t) {
    t14 = t("header.links.home");
    $[34] = t;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14) {
    t15 = <Link href={t12} className={t13} prefetch={false}>{t14}</Link>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== auth.isLoading || $[40] !== auth.isLoggedIn || $[41] !== pathname || $[42] !== t) {
    t16 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-progress")} className={`no-underline ${pathname === "/my-progress" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_progress")}</Link>;
    $[39] = auth.isLoading;
    $[40] = auth.isLoggedIn;
    $[41] = pathname;
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== auth.isLoading || $[45] !== auth.isLoggedIn || $[46] !== pathname || $[47] !== t) {
    t17 = !auth.isLoading && auth.isLoggedIn && <Link href={buildRouteUrl("/my-list")} className={`no-underline ${pathname === "/my-list" ? "text-white font-bold" : "text-[#666] regular"}`} prefetch={true}>{t("header.links.my_list")}</Link>;
    $[44] = auth.isLoading;
    $[45] = auth.isLoggedIn;
    $[46] = pathname;
    $[47] = t;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t15 || $[50] !== t16 || $[51] !== t17) {
    t18 = <div className="flex flex-col items-center mr-8"><div className="flex flex-row gap-x-3">{t15}{t16}{t17}</div></div>;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="md:ml-4"><Search /></div>;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t18) {
    t20 = <div className="flex md:hidden flex-row justify-between items-center px-4 md:px-10 py-4 bg-black w-full h-[56px] min-h-[56px]">{t18}{t19}</div>;
    $[54] = t18;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t11 || $[57] !== t20) {
    t21 = <><div className="flex flex-col w-screen min-w-full justify-between items-center z-10 fixed bg-black">{t11}{t20}</div></>;
    $[56] = t11;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  return t21;
}
export default Header;